import {FormControl, Row, Col} from 'react-bootstrap';
import {ServiceNavigator} from './navigator'

const Header = ({lang, service, account, onSearch}) => {
  
    const onChange = (e) => {
        //alert(e.target.value)
        onSearch && onSearch(e.target.value)

        //this.forceUpdate()
    }
  
    return (      
        <div className="Header SubHeader">
            <Row className="navbar-custom" expand="lg" style={{justifyContent:"center", display: "flex", height: '3.5rem'}}>
                <Col sm={1}>
                </Col>
                <Col  sm={6}>
                    {account.connected ?
                        <ServiceNavigator service={service} />
                    : null }
                </Col>
                <Col  sm={1} style={{ textAlign: 'right', marginTop:'0.5rem' }}>
                    <i className="fa fa-search" style={{ fontSize:'1.2rem' }} onClick={onChange} ></i>
                </Col>
                <Col  sm={3}>
                    <FormControl 
                        className="d-inline" 
                        style={{ textAlign: 'center', backgroundColor:'lightgray', marginTop:'0.5rem' }} 
                        name="Search" type="text" 
                        defaultValue=""
                        onChange={onChange}
                        placeholder="Search" />
                </Col>
            </Row>

        </div>
        
    )
}

export default Header;